export default "__VITE_ASSET__MFeC0B9w__"